<template>
    <div id="app">
        <notifications
            classes="app-notifications"
            position="bottom left"
            animation-type="css"
            width="400"
            v-bind:duration="3000"
            v-bind:speed="200"
        ></notifications>

        <browser-messages></browser-messages>

        <router-view></router-view>

        <maintenance v-bind:active="false"></maintenance>
    </div>
</template>

<script>
import { getEnvironment } from '@/helpers/utils';
import Lightgallery from '@/external/assorted/Lightgallery';
import BrowserMessages from '@/components/assorted/BrowserMessages';
import Maintenance from '@/components/assorted/Maintenance';

export default {
    data() {
        return {};
    },
    components: {
        'browser-messages': BrowserMessages,
        maintenance: Maintenance
    },
    methods: {},
    computed: {},
    created() {
        /* question on leave */
        if (getEnvironment() === 'production') {
            window.onbeforeunload = () => {
                if (this.$store.state.session.notSaved) {
                    return 'Sind Sie sicher?';
                } else {
                    return;
                }
            };
        }
        /* lightgallery */
        Lightgallery.init();
    },
    mounted() {}
};
</script>

<style lang="scss">
@import '@/scss/backend/style.scss';
</style>
